export default __webpack_public_path__ + "static/media/myclassic4.00167f06.png";